import { Endpoints } from '@matap/shared';
import { generateDataQueryHook } from './create-hooks';

export const useQueryTransactions = generateDataQueryHook(Endpoints.transactions.user.query, {
  queryKey: 'useQueryTransactions',
  gcTime: 0,
});
